import script from "./HrChip.vue?vue&type=script&setup=true&lang=js"
export * from "./HrChip.vue?vue&type=script&setup=true&lang=js"

import "./HrChip.vue?vue&type=style&index=0&id=573f9c1c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-573f9c1c"]])

export default __exports__
import QChip from 'quasar/src/components/chip/QChip.js';
import qInstall from "../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QChip});
